const SyncIcon = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24" height="24" viewBox="0 0 24 24"
		{...props}
	>
		<circle 
			cx="12" cy="12" r="9" 
			stroke="currentColor" 
			fill="none"
			strokeWidth="2" 
		/>
		<path 
			fillRule="evenodd" 
			clipRule="evenodd" 
			d="M11.9998 17.9998C15.3135 17.9998 17.9998 15.3136 17.9998 11.9998C17.9998 11.8871 17.9967 11.7751 17.9906 11.6639C17.7961 11.8717 17.567 12.037 17.3155 12.1508C17.0568 12.2678 16.7797 12.328 16.4997 12.328C16.2198 12.328 15.9426 12.2678 15.684 12.1508C15.4254 12.0338 15.1904 11.8623 14.9925 11.6462C14.7945 11.43 14.6375 11.1733 14.5304 10.8909C14.4233 10.6084 14.3682 10.3057 14.3682 10C14.3682 10.3057 14.313 10.6084 14.2059 10.8909C14.0988 11.1733 13.9418 11.43 13.7438 11.6462C13.5459 11.8623 13.3109 12.0338 13.0523 12.1508C12.7937 12.2678 12.5165 12.328 12.2366 12.328C11.9567 12.328 11.6795 12.2678 11.4209 12.1508C11.1623 12.0338 10.9273 11.8623 10.7293 11.6462C10.5314 11.43 10.3744 11.1733 10.2673 10.8909C10.1601 10.6084 10.105 10.3057 10.105 10C10.105 10.3057 10.0499 10.6084 9.94275 10.8909C9.83563 11.1733 9.67862 11.43 9.48068 11.6462C9.28274 11.8623 9.04776 12.0338 8.78915 12.1508C8.53053 12.2678 8.25335 12.328 7.97343 12.328C7.6935 12.328 7.41632 12.2678 7.15771 12.1508C6.89909 12.0338 6.66411 11.8623 6.46617 11.6462C6.3075 11.4729 6.17512 11.2736 6.07366 11.0558C6.02506 11.3633 5.99982 11.6786 5.99982 11.9998C5.99982 15.3136 8.68611 17.9998 11.9998 17.9998Z" 
			fill="currentColor"
		/>
	</svg>
)

export default SyncIcon